import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorP2P = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="m9.759 14.531.16-.975 2.119-1.541c.141-.103.263-.199.365-.288.104-.091.187-.185.25-.28a.817.817 0 0 0 .125-.32.572.572 0 0 0-.03-.33.425.425 0 0 0-.19-.211.642.642 0 0 0-.316-.074.776.776 0 0 0-.343.076.683.683 0 0 0-.26.222.85.85 0 0 0-.137.356h-1.285a1.96 1.96 0 0 1 .387-.907c.201-.254.456-.449.764-.585.31-.137.658-.205 1.045-.205.399 0 .735.064 1.008.192.272.127.47.306.591.537.124.23.159.501.105.812a1.656 1.656 0 0 1-.217.57c-.11.19-.288.399-.533.63-.243.229-.581.502-1.013.82l-.53.39-.005.028h1.947l-.18 1.083H9.76Zm4.422 0 .828-4.994h2.152c.37 0 .682.073.935.22.254.146.435.351.546.617.11.264.136.574.078.929a2.04 2.04 0 0 1-.39.934c-.2.26-.454.46-.764.602-.309.14-.654.21-1.037.21h-.746l-.248 1.482h-1.354Zm2.25-2.536h-.473l.23-1.375h.477c.159 0 .29.027.392.083a.452.452 0 0 1 .219.234c.044.1.054.223.032.366a.765.765 0 0 1-.448.61 1.039 1.039 0 0 1-.429.082ZM6.078 9.537 5.25 14.53h1.354l.247-1.483h.746c.383 0 .729-.07 1.037-.21.31-.14.565-.341.765-.602.2-.261.33-.573.39-.934.058-.354.032-.664-.079-.929a1.252 1.252 0 0 0-.545-.617c-.253-.146-.565-.22-.935-.22H6.078ZM7.5 11.995h-.473l.23-1.375h.476c.16 0 .29.027.392.083a.452.452 0 0 1 .22.234c.043.1.054.222.031.365a.766.766 0 0 1-.448.61 1.04 1.04 0 0 1-.428.083Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M12 3.75a8.21 8.21 0 0 0-4.745 1.5H9.3a.75.75 0 0 1 0 1.5H5.511a.75.75 0 0 1-.823-1.2A9.728 9.728 0 0 1 12 2.25c5.385 0 9.75 4.365 9.75 9.75a.75.75 0 0 1-1.5 0A8.25 8.25 0 0 0 12 3.75Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.733 9.733 0 0 0 7.611-3.656.75.75 0 0 0 .134-.684.75.75 0 0 0-.745-.66h-4a.75.75 0 0 0 0 1.5h2.386A8.25 8.25 0 0 1 3.75 12Z"
    />
  </svg>
);
export default SvgTwoColorP2P;
